import api from '@pray/shared/utils/api';

import type { SeedSourceValue, SyncSeedsResponse } from './types';

const SYNC_URL = '/web/studio/admin/seed-emails/seeds/sync';

export type PostSyncSeedsParams = {
  addEmails: string[];
  removeSeedIds: string[];
  source?: SeedSourceValue;
};

/**
 * Applies the diff the dialog showed. The additions go through the same create-or-restore path as
 * the CSV import and the removals are the same soft delete the Delete button uses, so `Undo` after
 * a sync is the same restore as `Undo` after a delete.
 */
export async function postSyncSeeds({ addEmails, removeSeedIds, source = 'inbox_monster' }: PostSyncSeedsParams) {
  const res = await api.executePostRequest<{ data: SyncSeedsResponse }>(SYNC_URL, {
    add_emails: addEmails,
    remove_seed_ids: removeSeedIds,
    source,
  });
  return res.data.data;
}
